// import i18n from '@/lang/index'

export default function RETURN_DATA() {
  return {
    defaultMenu: [
      {
        isShowBottom: true,
        title: 'HS Code',
        titleCn: 'HS编码',
        children: [
          {
            title: 'WCO',
            titleCn: 'WCO',
            href: 'http://www.wcoomd.org/en/topics/nomenclature/overview.aspx'
          },
          // {
          //   title: 'WTO',
          //   titleCn: 'WTO',
          //   href: 'http://tariffdata.wto.org/TariffList.aspx'
          // },
          {
            title: 'Australia',
            titleCn: 'Australia',
            href: 'https://www.border.gov.au/Busi/Tari/Curr'
          },
          // {
          //   title: 'Canada CBSA',
          //   titleCn: 'Canada CBSA',
          //   href: 'http://www.cbsa-asfc.gc.ca/trade-commerce/tariff-tarif/2015/html/tblmod-eng.html'
          // },
          {
            title: 'Canada CPC',
            titleCn: 'Canada CPC',
            href: 'https://www.canadapost.ca/cpotools/apps/wtz/personal/findHsCode?execution=e2s1'
          },
          // {
          //   title: 'Europe',
          //   titleCn: 'Europe',
          //   href: 'http://ec.europa.eu/taxation_customs/customs/customs_duties/tariff_aspects/harmonised_system/index_en.htm'
          // },
          // {
          //   title: 'New Zealand',
          //   titleCn: 'New Zealand',
          //   href: 'http://www.customs.govt.nz/news/utilities/pages/tariff-classifications.aspx'
          // },
          {
            title: 'Russian',
            titleCn: 'Russian',
            href: 'http://russian-customs.org/legislation/tariff/index.html'
          },
          {
            title: 'USA',
            titleCn: 'USA',
            href: 'http://hts.usitc.gov/'
          }
        ]
      }
    ]
  }
}
